import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { retry, timer } from 'rxjs';
import { ArcgisDomainService } from '../../services/arcgis-domain-service';

const MAX_RETRIES = 3;
const BASE_DELAY_MS = 1000;

function shouldRetry(status: number): boolean {
  return status >= 500 || status === 0;
}

function isRetryableMethod(req: HttpRequest<unknown>): boolean {
  return ['GET', 'HEAD', 'OPTIONS'].includes(req.method);
}

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  const arcgisDomain = inject(ArcgisDomainService);
  if (arcgisDomain.isArcgisRequest(req.url)) {
    return next(req);
  }
  if (!isRetryableMethod(req)) return next(req);

  return next(req).pipe(
    retry({
      count: MAX_RETRIES,
      delay: (error, retryCount) => {
        if (!shouldRetry(error.status ?? 0)) throw error;
        return timer(BASE_DELAY_MS * Math.pow(2, retryCount));
      },
    })
  );
};
